import React from 'react';

const Logo = ({ size = 32, text = true }) => {
  const stroke = '#0ea5e9';
  return (
    <div className="flex items-center space-x-2">
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="8" y="12" width="48" height="40" rx="6" fill="#0ea5e9" opacity="0.08" />
        <path
          d="M20 20h12l-6 10h10l-14 14 4-12h-6l4-12z"
          stroke={stroke}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M36 20h8"
          stroke={stroke}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M38 28h10"
          stroke={stroke}
          strokeWidth="3"
          strokeLinecap="round"
          opacity="0.8"
        />
        <path
          d="M36 36h8"
          stroke={stroke}
          strokeWidth="3"
          strokeLinecap="round"
          opacity="0.6"
        />
      </svg>
      {text && <span className="text-xl font-bold text-primary-600 dark:text-primary-400">Tailor Shop</span>}
    </div>
  );
};

export default Logo;


